module.exports = {
  SET_QUERY: 'SET_QUERY',
  SHOW_MODAL: 'SHOW_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  SET_ACTIVE_MOBILE_LINK: 'SET_ACTIVE_MOBILE_LINK',
  SCROLL_MOBILE_NAV_RIGHT: 'SCROLL_MOBILE_NAV_RIGHT'
}